import { render, staticRenderFns } from "./TemResult.vue?vue&type=template&id=7b3e829b&scoped=true&"
import script from "./TemResult.vue?vue&type=script&lang=js&"
export * from "./TemResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3e829b",
  null
  
)

export default component.exports